import { useState } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Submission } from "@/models/database/submissions/Submission.model";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export const useSubmitScore = () => {
  const user = useCurrentUserProfile((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const submitScore = async (values: Submission) => {
    if (!user) {
      setError(new Error("User not authenticated"));
      return;
    }
    setLoading(true);

    try {
      await collectionRef
        .submissions(brand.tenantId)
        .doc()
        .set({
          ...values,
        });

      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return { submitScore, loading, error };
};
